import styled from 'styled-components';

const StyledText = styled.span`
	position: absolute;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	font-weight: 400;
	color: #ffffff;
	text-shadow: 1px 1px #202020;
	user-select: none;
`;

export { StyledText };
